/* global process */
import './global.css';
import { apiPlugin, storyblokInit } from 'gatsby-source-storyblok';

// Initialise the Storyblok SDK once for the whole site. This loads the
// visual editor bridge when the page is opened from Storyblok (the URL then
// carries `_storyblok_tk`), so every template using useStoryblokState gets
// live updates in the editor, not only the configurator.
storyblokInit({
  accessToken: process.env.GATSBY_STORYBLOK_API_KEY,
  apiOptions: {
    region: 'eu',
  },
  use: [apiPlugin],
});
